import { render, staticRenderFns } from "./ListLocalVotacion.vue?vue&type=template&id=7c01e1d5&scoped=true"
import script from "./ListLocalVotacion.vue?vue&type=script&lang=js"
export * from "./ListLocalVotacion.vue?vue&type=script&lang=js"
import style0 from "./ListLocalVotacion.vue?vue&type=style&index=0&id=7c01e1d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c01e1d5",
  null
  
)

export default component.exports